// extracted by mini-css-extract-plugin
export default {"responsiveContainer":"responsiveContainer-AS9_lPrM","gameVoteContainer":"gameVoteContainer-QP2On66Q"};